import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance, AxiosResponse } from 'axios';
import { tKeys, useTranslation } from 'locales/index';
import { type ApiError, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function refreshBalanceFn(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;
  return instance.post('analytics/aged-balance/refresh');
}

export function useRefreshBalance() {
  const { t } = useTranslation();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<AxiosResponse, ApiError>({
    mutationFn: () => refreshBalanceFn(axiosInstance),
    onSuccess: () => {
      notifications.show({ message: t(tKeys.ANALYTICS.REFRESH_BALANCE_SUCCESS) });
    },
  });

  return addActionNameToMutationResult<AxiosResponse, ApiError, void, 'refreshBalance'>(
    'refreshBalance',
    mutation,
  );
}
